// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"AddingProduct_pageHolder__aJ0-2","centerHolder":"AddingProduct_centerHolder__18Mvs"};